import { Provider } from '@angular/core';
import { AgentSearchService } from './agent-search.service';
import { AgentSqlSearchService } from './agent-sql-search.service';

/**
 * Binds the agent-search token to the SQL implementation.
 *
 * There is one implementation now, so this is a single alias rather than the choice it
 * briefly was. The token stays because the consumers are written against it, and because
 * the next backend change should be as cheap as the last one.
 */
export function provideAgentSearch(): Provider[] {
  return [{ provide: AgentSearchService, useExisting: AgentSqlSearchService }];
}
